module.exports = __webpack_public_path__ + "static/media/RainierCompressed.1c820ae6.jpg";